<template>
  <div>
    <van-cell title="手机号" is-link :value="phone" class="m-t-045" />
    <van-cell
      title="微信"
      is-link
      :value="wxName == null || undefined ? '尚未绑定' : wxName"
    />
    <van-cell
      title="QQ"
      is-link
      :value="QQName == null || undefined ? '尚未绑定' : QQName"
    />
    <van-cell
      title="协议管理"
      is-link
      @click="goAgreementList"
    />
     <van-cell
      title="考试报名"
      is-link
      @click="goExamList"
    />
    <van-cell title="问题投诉" @click="complaint" is-link class="m-t-045" />
    <div class="text-c m-t-3" @click="logout">
      <van-button class="xz-button-info outLogin m-t-11">退出账号</van-button>
    </div>
  </div>
</template>

<script>
import { CacheModule } from "@/utils/commonUtils.js";
import {  mutations } from "@/observable/store";

import { ImagePreview } from "vant";
export default {
  data() {
    return {};
  },
  methods: {
    // 去协议列表
    goAgreementList(){
      this.$router.push({
        path: "/agreementList",
      });
    },
    goExamList(){
      this.$router.push({
        path: "/examList",
      });
    },
    complaint() {
      ImagePreview({
        images: [
          "http://webxiaozhu.oss-cn-beijing.aliyuncs.com/images/lianggkoK1t",
        ],
        closeable: true,
      });
    },
    logout(){
      CacheModule.remove("loginPhone");
      CacheModule.remove("setToken");
      CacheModule.remove("qqOpenidType");
      CacheModule.remove("wxOpenidType");
      CacheModule.remove("uid");
      CacheModule.remove("userInfo");
      sessionStorage.clear();
      mutations.getToken(false);
      this.$store.commit("Login/editIsUser", false);
      this.$router.replace('/');
      // location.reload();
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(localStorage.getItem("userInfo"));
    },
    phone() {
      if(this.userInfo == null) {
        return '****'
      } else {
        let str = String(this.userInfo.loginname),
        strLen = str.slice(-8, -4);
      return str.replace(strLen, "****");
      }
      
    },
    wxName() {
      if(!this.isNotNull(this.userInfo)) return '小筑教育'
      return this.userInfo.wxName;
    },
    QQName() {
      if(!this.isNotNull(this.userInfo)) return '小筑教育'
      return this.userInfo.QQName;
    },
  },
};
</script>

<style lang="less" scoped>
.outLogin {
  border-radius: 1.3rem;
  height: 2.1rem;
  width: 11.5rem;
}
</style>
